module.exports = __webpack_public_path__ + "img/graph2-g.463b66be.svg";